"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SquaredButtonStyled = exports.modifiers = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
exports.modifiers = {
  primaryNoHover: function primaryNoHover(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      &:hover {\n        background-color: ".concat(theme.farmProject.dark_gray, ";\n        border: 1px solid transparent;\n        span {\n          color: ").concat(theme.farmProject.gray_3, ";\n        }\n      }\n    ")
    };
  },
  secondary: function secondary(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: "\n      background-color: ".concat(theme.farmProject.gray_3, ";\n\n      span {\n        color: ").concat(theme.farmProject.dark_gray, ";\n      }\n\n      &:hover {\n      border-color: ").concat(theme.farmProject.light_gray, ";\n      background-color: ").concat(theme.farmProject.white, ";\n        span {\n          color: ").concat(theme.farmProject.dark_gray, ";\n        }\n      }\n    ")
    };
  },
  lined: function lined(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: "\n      background-color: ".concat(theme.farmProject.white, ";\n      border: solid 1px ").concat(theme.farmProject.brand_primary, ";\n\n      span {\n        color: ").concat(theme.farmProject.dark_gray, ";\n      }\n\n      &:hover {\n      border-color: ").concat(theme.farmProject.light_gray, ";\n      background-color: ").concat(theme.farmProject.light_gray, "20;\n        span {\n          color: ").concat(theme.farmProject.dark_gray, ";\n        }\n      }\n    ")
    };
  },
  white: function white(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: "\n      background-color: ".concat(theme.farmProject.white, ";\n      border-color: ").concat(theme.farmProject.light_gray, "30;\n\n      span {\n        color: ").concat(theme.farmProject.dark_gray, ";\n      }\n\n      &:hover {\n        border-color: ").concat(theme.farmProject.light_gray, "50;\n        background-color: ").concat(theme.farmProject.white, ";\n        span {\n          color: ").concat(theme.farmProject.dark_gray, ";\n        }\n      }\n    ")
    };
  },
  whiteActive: function whiteActive(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: "\n      background-color: ".concat(theme.farmProject.white, ";\n      border-color: ").concat(theme.farmProject.green, ";\n\n      span {\n        color: ").concat(theme.farmProject.dark_gray, ";\n      }\n\n      &:hover {\n        border-color: ").concat(theme.farmProject.light_gray, ";\n        background-color: ").concat(theme.farmProject.white, ";\n        span {\n          color: ").concat(theme.farmProject.dark_gray, ";\n        }\n      }\n    ")
    };
  },
  tertiary: function tertiary(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: "\n      background-color: ".concat(theme.farmProject.brand_primary, ";\n      border: solid 1px ").concat(theme.farmProject.brand_primary, ";\n\n      span {\n        color: ").concat(theme.farmProject.gray_3, ";\n      }\n\n      &:hover {\n        background-color: transparent;\n        border: solid 1px ").concat(theme.farmProject.brand_primary, ";\n\n        span {\n          color: ").concat(theme.farmProject.gray, ";\n        }\n      }\n    ")
    };
  },
  quaternary: function quaternary(_ref7) {
    var theme = _ref7.theme;
    return {
      styles: "\n      background-color: ".concat(theme.farmProject.dark_green, ";\n      border: solid 1px ").concat(theme.farmProject.dark_green, ";\n\n      span {\n        color: ").concat(theme.farmProject.gray_3, ";\n      }\n\n      &:hover {\n        background-color: transparent;\n        border: solid 1px ").concat(theme.farmProject.dark_green, ";\n\n        span {\n          color: ").concat(theme.farmProject.gray, ";\n        }\n      }\n    ")
    };
  },
  inverted: function inverted(_ref8) {
    var theme = _ref8.theme;
    return {
      styles: "\n      background-color: transparent;\n      border-color: ".concat(theme.farmProject.dark_gray, ";\n      span {\n        color: ").concat(theme.farmProject.dark_gray, ";\n      }\n      &:hover {\n        background-color: ").concat(theme.farmProject.dark_gray, ";\n        border-color: transparent;\n\n        span {\n          color: ").concat(theme.farmProject.gray_3, ";\n        }\n      }\n    ")
    };
  },
  invertedTertiary: function invertedTertiary(_ref9) {
    var theme = _ref9.theme;
    return {
      styles: "\n      background-color: transparent;\n      border-color: transparent;\n      span {\n        color: ".concat(theme.farmProject.dark_gray, ";\n      }\n      &:hover {\n        border-color: ").concat(theme.farmProject.brand_primary, ";\n      }\n    ")
    };
  },
  invertedNoHover: function invertedNoHover(_ref10) {
    var theme = _ref10.theme;
    return {
      styles: "\n      background-color: transparent;\n      border-color: ".concat(theme.farmProject.dark_gray, ";\n      span {\n        color: ").concat(theme.farmProject.dark_gray, ";\n      }\n      &:hover {\n        border-color: ").concat(theme.farmProject.dark_gray, ";\n      }\n    ")
    };
  },
  disabled: function disabled() {
    return {
      styles: "\n      opacity: 0.2;\n      pointer-events: none;\n\n      &:hover {\n        background-color: inherit;\n        border: 1px solid transparent;\n\n        span {\n          color: inherit;\n        }\n      }\n    "
    };
  },
  newDisabled: function newDisabled(_ref11) {
    var theme = _ref11.theme;
    return {
      styles: "\n      pointer-events: none;\n      border: none;\n      background-color: ".concat(theme.farmProject.light_gray, ";\n\n      span {\n        color: ").concat(theme.farmProject.gray_3, ";\n      }\n    ")
    };
  },
  greenDisabled: function greenDisabled(_ref12) {
    var theme = _ref12.theme;
    return {
      styles: "\n      pointer-events: none;\n      border: none;\n      background-color: ".concat(theme.farmProject.green_disabled, ";\n\n      span {\n        color: ").concat(theme.farmProject.gray_3, ";\n      }\n    ")
    };
  },
  ghost: function ghost(_ref13) {
    var theme = _ref13.theme;
    return {
      styles: "\n      pointer-events: none;\n      color: ".concat(theme.farmProject.mid_gray, ";\n      border-color: ").concat(theme.farmProject.mid_gray, ";\n      span {\n        color: ").concat(theme.farmProject.mid_gray, ";\n      }\n    ")
    };
  },
  fluid: function fluid() {
    return {
      styles: "\n    width: 100%;\n    "
    };
  }
};
exports.SquaredButtonStyled = styled_components_1.default.button.attrs({
  className: 'Button'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 2.15rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  margin: 0;\n  border: 1px solid transparent;\n  transition: all 0.25s ease-in-out;\n  cursor: pointer;\n  box-sizing: border-box;\n  border-radius: 0.125rem;\n\n  span {\n    font-family: ", ";\n    font-size: 0.75rem;\n    letter-spacing: 0.09375rem;\n    color: ", ";\n    text-decoration: none;\n    white-space: nowrap;\n  }\n\n  &:hover {\n    background-color: transparent;\n    border: 1px solid ", ";\n    span {\n      color: ", ";\n    }\n  }\n\n  ", "\n\n  ", ";\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.farmProject.dark_gray;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.farmProject.font_family;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.farmProject.gray_3;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.farmProject.dark_gray;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.farmProject.dark_gray;
}, function (props) {
  var _a, _b;
  return ((_b = (_a = props.modifiers) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, 'loading')) && atoms_utils_theme_1.loadingIconAnimation;
}, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));